import { Toast } from 'mint-ui'
import md5 from 'blueimp-md5'
import sha256 from 'js-sha256'

// 版本号比较
// Return 1 if a > b
// Return -1 if a < b
// Return 0 if a == b
export function compare (a, b) {
  if (a === b) {
    return 0
  }

  var a_components = a.split('.')
  var b_components = b.split('.')

  var len = Math.min(a_components.length, b_components.length)

  // loop while the components are equal
  for (var i = 0; i < len; i++) {
    // A bigger than B
    if (parseInt(a_components[i]) > parseInt(b_components[i])) {
      return 1
    }
    // B bigger than A
    if (parseInt(a_components[i]) < parseInt(b_components[i])) {
      return -1
    }
  }
  // If one's a prefix of the other, the longer one is greater.
  if (a_components.length > b_components.length) {
    return 1
  }
  if (a_components.length < b_components.length) {
    return -1
  }
  // Otherwise they are the same.
  return 0
}

// 显示tips
export function showTips (tips) {
  let instance = Toast(tips)
  setTimeout(() => {
    instance.close()
  }, 2000)
}

// js 浮点计算
// 加法
export function accAdd (arg1, arg2) {
  var r1, r2, m, c
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  return (arg1 + arg2) / m
}

// 乘法
export function accMul (arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 减法
export function accSub (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) // last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

/**
 * 文本框根据输入内容自适应高度
 * @param                {HTMLElement}        输入框元素
 * @param                {Number}             设置光标与输入框保持的距离(默认0)
 * @param                {Number}             设置最大高度(可选)
 */
export function autoTextarea (elem, extra, maxHeight) {
  extra = extra || 0
  var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window
  var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera')
  var addEvent = function (type, callback) {
    elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback)
  }
  var getStyle = elem.currentStyle ? function (name) {
    var val = elem.currentStyle[name]
    if (name === 'height' && val.search(/px/i) !== 1) {
      var rect = elem.getBoundingClientRect()
      return rect.bottom - rect.top -
        parseFloat(getStyle('paddingTop')) -
        parseFloat(getStyle('paddingBottom')) + 'px'
    }
    return val
  } : function (name) {
    return window.getComputedStyle(elem, null)[name]
  }
  var minHeight = parseFloat(getStyle('height'))
  elem.style.resize = 'none'
  var change = function () {
    var scrollTop
    var height
    var padding = 0
    var style = elem.style
    if (elem._length === elem.value.length) return
    elem._length = elem.value.length
    if (!isFirefox && !isOpera) {
      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'))
    }
    scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    elem.style.height = minHeight + 'px'
    if (elem.scrollHeight > minHeight) {
      if (maxHeight && elem.scrollHeight > maxHeight) {
        height = maxHeight - padding
        style.overflowY = 'auto'
      } else {
        height = elem.scrollHeight - padding
        style.overflowY = 'hidden'
      }
      style.height = height + extra + 'px'
      scrollTop += parseInt(style.height) - elem.currHeight
      document.body.scrollTop = scrollTop
      document.documentElement.scrollTop = scrollTop
      elem.currHeight = parseInt(style.height)
    }
  }
  addEvent('propertychange', change)
  addEvent('input', change)
  addEvent('focus', change)
  change()
}

// 格式化时间
const timeFormat = function (date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

export function transformDate (date) {
  var date_obj = {
    cn_date: date.getMonth() + 1 + '月' + date.getDate() + '日' + '周' + '日一二三四五六'.split('')[date.getDay()],
    time: date.getHours() + ':' + date.getMinutes(),
    week: '周' + '日一二三四五六'.split('')[date.getDay()],
    param: timeFormat(date, 'yyyy/MM/dd hh:mm'),
    date: timeFormat(date, 'yyyy/MM/dd')
  }
  return date_obj
}

// 时间格式还原
export function restoreDate (date, hour, minute) {
  var _now = new Date()
  var _now_month = _now.getMonth() + 1
  var _now_year = _now.getFullYear()
  var _date = date.slice(0, -3).split('月')
  var _year = (_date[0] >= _now_month) ? _now_year : _now_year + 1
  var _hour = hour.slice(0, -1)
  var _minute = minute.slice(0, -1)
  if (_hour.length === 1) {
    _hour = '0' + _hour
  }
  if (_minute.length === 1) {
    _minute = '0' + _minute
  }
  return {
    param: _year + '/' + _date[0] + '/' + _date[1] + ' ' + _hour + ':' + _minute,
    date: date.slice(0, -2),
    week: date.slice(-2),
    time: _hour + ':' + _minute
  }
}

// 截取字符串
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return unescape(r[2])
  }
  return null
}

// webviewJavascriptBridge
export function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

export function signGenerate (params) {
  var arg = []
  for (var i in params) {
    if (typeof params[i] === 'undefined' || (!params[i] && typeof (params[i]) !== 'undefined' && params[i] !== 0)) {
      params[i] = '' // 防止生成报错
    }
    if (typeof params[i] === 'object') {
      arg.push(i + '=' + JSON.stringify(params[i]))
    } else {
      arg.push(i + '=' + params[i])
    }
  }
  var sign = arg.sort().join('')
  return md5('ltb_dudubus' + sign + '5b1a212349ca1234oe3124234234f30a5')
}

export function signGenerate2 (params) {
  var arg = []
  for (var i in params) {
    if (typeof params[i] === 'undefined' || (!params[i] && typeof (params[i]) !== 'undefined' && params[i] !== 0)) {
      params[i] = '' // 防止生成报错
    }
    if (typeof params[i] === 'object') {
      arg.push(i + '=' + JSON.stringify(params[i]))
    } else {
      arg.push(i + '=' + params[i])
    }
  }
  var sign = arg.sort().join('')
  var str1 = md5('ltb_dudubus' + sign + '5b1a212349ca1234oe3124234234f30a5')
  var str2 = sha256(str1)
  return str1 + str2
}

export function setDocumentTitle (t) {
  document.title = t
  var i = document.createElement('iframe')
  i.style.display = 'none'
  i.onload = function () {
    setTimeout(function () {
      i.remove()
    }, 9)
  }
  i.src = '//m.baidu.com/favicon.ico'
  document.body.appendChild(i)
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js